module.exports = __webpack_public_path__ + "img/gear.4b9e921e.png";